// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1DirP","actions":"GroupTable_actions__xJe1y","deleteModalFooter":"GroupTable_deleteModalFooter__SALV3"};